import styled from 'styled-components/macro';
import { colorCoreGray500, colorCoreGray800, colorWhiteTransparent300, defaultTransparent, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularLinkLevel2 } from '@yme/tokens/typography';
export const FlexWrapperStyled = styled(FlexWrapper) `
  padding: ${({ isRightToLeft }) => isRightToLeft ? '10px 10px 10px 16px' : '10px 16px 10px 10px'};
  background: ${colorWhiteTransparent300};
  border: 1px solid ${colorCoreGray500};
  border-radius: ${CORNER_RADIUS.s};
  white-space: nowrap;
  height: 44px;

  &:hover {
    cursor: pointer;

    border-color: ${colorCoreGray800};
  }
`;
export const RegularLinkLevel2Styled = styled(RegularLinkLevel2) `
  background: ${defaultTransparent};
  border: 0;
`;
